import { request } from '../../../functions/request';
import { route } from '../../../routes/web';
import { loginRequestInvalid, loginRequestValid } from './postLogin';
import { setMessage } from '../../../actions/setMessage';
import { ParseError } from '../../../functions/error-parse';

export const user_request_invalid = 'user_request_invalid';
export const user_request_send = 'user_request_send';
export const user_request_valid = 'user_request_valid';

export function userRequestInvalid() {
    return {
        type: user_request_invalid,
    };
}

export function userRequestSend() {
    return {
        type: user_request_send,
    };
}

export function userRequestValid(data) {
    return {
        type: user_request_valid,
        data: data,
    };
}

export function fetchUser(data) {
    return function (dispatch) {
        dispatch(userRequestSend());
        request(
            route.auth.getUser,
            data,
            (data) => {
                if (data.success) {
                    return dispatch(loginRequestValid(data.user));
                }
                if (data.msg) {
                    dispatch(setMessage(ParseError(data.msg), 'error'));
                } else {
                    dispatch(setMessage('Ошибка при авторизации', 'error'));
                }
                dispatch(loginRequestInvalid());
            },
            (error) => {
                dispatch(loginRequestInvalid());
            }
        );
    };
}
